// Full-screen staged transmission intro. Lines appear one at a time, then hands off.
import { useEffect, useState } from "react";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";

export const TransmissionIntro = ({ lines, onDone, testId = "transmission-intro" }) => {
  const reduced = useReducedMotion();
  const [idx, setIdx] = useState(0);
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (reduced) { setShow(false); onDone?.(); return; }
    if (idx < lines.length - 1) {
      const t = setTimeout(() => setIdx((i) => i + 1), 1600);
      return () => clearTimeout(t);
    }
    const t = setTimeout(() => { setShow(false); onDone?.(); }, 1900);
    return () => clearTimeout(t);
  }, [idx, reduced, lines.length, onDone]);

  const skip = () => { setShow(false); onDone?.(); };

  return (
    <AnimatePresence>
      {show && (
        <motion.div className="fixed inset-0 z-[80] flex items-center justify-center bg-onyx"
          initial={{ opacity: 1 }} exit={{ opacity: 0, transition: { duration: 0.6 } }} data-testid={testId}>
          <div className="grain-dark pointer-events-none absolute inset-0" />
          <div className="vignette pointer-events-none absolute inset-0" />
          <AnimatePresence mode="wait">
            <motion.div key={idx} className="px-6 text-center"
              initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -8 }}
              transition={{ duration: 0.5 }}>
              {lines[idx].kicker && (
                <p className="font-mono text-[10px] uppercase tracking-[0.5em] text-gold">
                  <span className="mr-2 inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-gold align-middle" aria-hidden="true" />
                  {lines[idx].kicker}
                </p>
              )}
              <h1 className="mt-4 font-display text-3xl uppercase leading-[0.95] tracking-tight text-metallic sm:text-5xl" data-testid={`${testId}-line`}>
                {lines[idx].text}
              </h1>
            </motion.div>
          </AnimatePresence>
          <button onClick={skip} data-testid={`${testId}-skip`}
            className="absolute bottom-6 right-6 border border-silver/30 px-4 py-2 font-mono text-[10px] uppercase tracking-[0.3em] text-silver/70 transition-colors hover:border-gold hover:text-goldlight">
            Skip
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
